import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators, compose } from 'redux';
import get from 'lodash/get';

import { getActiveAgencyUser } from '../../shared/redux/selectors';

import {
  loadAgency,
  updateAgency
} from '../../shared/redux/entities/actions';

function mapStateToProps(state){
  const activeUser = getActiveAgencyUser(state);
  return {
    agency:get(state,['entities','agencies',activeUser.agencyId],{})
  };
}

function mapDispatchToProps(dispatch){
  //TODO: Bind Redux action creators to AgencyManageAccoutInfo
  return bindActionCreators({
    loadAgency,
    updateAgency
  },dispatch);
}

export default compose(
  withRouter,
  connect(mapStateToProps,mapDispatchToProps)
);



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccoutInfo/connect.js